<template>
  <label class="radio" :class="{ 'radio--disabled': props.isDisabled }">
    <input
      type="radio"
      @change="onChange"
      :name="props.name"
      :value="props.value"
      :disabled="props.isDisabled"
      :checked="isCheck"
      tabindex="0"
    />
    <div class="radio__box" :class="{ 'radio__box--check': isCheck }"></div>
    <div class="radio__signs" v-if="isLeft">
      <span class="radio__main-sign">
        <slot name="mainSign"></slot>
      </span>
      <span class="radio__hint-sign">
        <slot name="hintSign"></slot>
      </span>
    </div>
  </label>
</template>

<script lang="ts" setup>
import { computed, defineProps, defineEmits, useSlots, PropType } from "vue";
const emit = defineEmits<{
  (eventName: "update:modelValue", value: boolean): void;
}>();

const slots = useSlots();

/**
 * Есть ли слот для лейбла
 */
const isLeft = computed(() => slots && slots.mainSign && slots.mainSign());

/**
 * События
 */
const props = defineProps({
  /**
   * Значение
   */
  modelValue: { type: [Number, String, Object] as PropType<number | string | object | null>, default: null },
  /**
   * Название группы
   */
  name: { type: String, default: "" },
  /**
   * Значение которое принимает modelValue при выборе кнопки
   */
  value: { type: [Number, String, Object] as PropType<number | string | object | null>, default: null },
  /**
   * Дизейбл
   */
  isDisabled: { type: Boolean as PropType<boolean>, default: false },
});
/**
 * При изменении значения
 */
const onChange = (e: Event) => {
  if (props.isDisabled) return;
  let value = (e.target as HTMLInputElement)?.value;
  let formated = typeof value == 'string' ? value : JSON.parse(value);
  emit("update:modelValue", formated);
};

/**
 * Внутреннее значение
 */
const isCheck = computed(() => {
  return props.modelValue == props.value;
});
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
